// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_FormURLEncoded from "../Data.FormURLEncoded/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var stripFUE = /* #__PURE__ */ (function () {
    var $6 = Data_Maybe.fromMaybe(Data_FormURLEncoded.fromArray(Data_Monoid.mempty(Data_Monoid.monoidArray)));
    var $7 = Data_String_CodePoints.drop(1);
    var $8 = Data_String_CodePoints.dropWhile(function (v) {
        return Data_Eq.notEq(Data_String_CodePoints.eqCodePoint)(v)(Data_String_CodePoints.codePointFromChar("?"));
    });
    return function ($9) {
        return $6(Data_FormURLEncoded.decode($7($8($9))));
    };
})();
var setQueryParams = function (params) {
    return function (uri) {
        var url = Data_String_CodePoints.takeWhile(function (v) {
            return Data_Eq.notEq(Data_String_CodePoints.eqCodePoint)(v)(Data_String_CodePoints.codePointFromChar("?"));
        })(uri);
        var newKeys = Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return new Data_Tuple.Tuple(v.value0, new Data_Maybe.Just(v.value1));
        })(params);
        var query = Data_Maybe.fromMaybe("")(Data_FormURLEncoded.encode(Data_FormURLEncoded.fromArray(Data_Array.union(Data_Tuple.eqTuple(Data_Eq.eqString)(Data_Maybe.eqMaybe(Data_Eq.eqString)))(newKeys)(Data_FormURLEncoded.toArray(stripFUE(uri))))));
        return url + ("?" + query);
    };
};
var makeImgUrl = function (urn) {
    return $foreign.imgixUrl + urn;
};
var adjustImage = function (params) {
    return setQueryParams(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ new Data_Tuple.Tuple("w", params.w), new Data_Tuple.Tuple("h", params.h) ])(Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(params.crop)([ new Data_Tuple.Tuple("crop", "focalpoint"), new Data_Tuple.Tuple("fit", "crop") ])));
};
export {
    imgixUrl
} from "./foreign.js";
export {
    makeImgUrl,
    stripFUE,
    setQueryParams,
    adjustImage
};
//# sourceMappingURL=index.js.map
